// extracted by mini-css-extract-plugin
export const carouselWrapper = "carousel-module--carousel-wrapper--2uESQ";
export const carouselButtonLeft = "carousel-module--carousel-button-left--wM-XF";
export const carouselButtonRight = "carousel-module--carousel-button-right--3PtIw";
export const carouselHeader = "carousel-module--carousel-header--3yVws";
export const carouselHeaderButtons = "carousel-module--carousel-header-buttons--j3EG7";
export const carouselHeaderDescription = "carousel-module--carousel-header-description--15tso";
export const carouselHeaderDescriptionButtonsRow = "carousel-module--carousel-header-description-buttons-row--2rkhQ";
export const carouselHeaderDescriptionButtons = "carousel-module--carousel-header-description-buttons--11CpJ";
export const mobileSeeMore = "carousel-module--mobile-see-more--2giC1";